// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"40dc2312","229":"3871d7ec","349":"cebeead7"}[chunkId] + ".chunk.js";
};